import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CediStoreService } from '../../cedi-store.service';
import { RoutingService } from '../../../shared/providers/routing.service';
import {
  City,
  Country,
  Company,
  NewPointCedi,
} from 'src/app/components/massive/pages/create/components/parametrizacion/parametrizacion.interface';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { ICoordinates } from '../../../demo/pages/search/components/layout-search/layout-search.interface';

@Component({
  selector: 'app-load-store',
  templateUrl: './load-store.component.html',
  styleUrls: ['./load-store.component.sass'],
  providers: [MessageService],
})
export class LoadStoreComponent implements OnInit, AfterViewInit {
  public hostUrlBack: string;
  public labelButtonCedi = 'EDITAR CEDI';
  public showAddress = false;
  public showEditCedi = false;
  public addressError = false;
  public foundCard = false;
  public notFoundCard = true;
  public editCedi: NewPointCedi;
  public addressToEdit = '';
  public addressPoint: NewPointCedi[] = [];
  public addressNotFound: NewPointCedi[] = [];
  public addressFound: NewPointCedi[] = [];
  public mapCoordinates: ICoordinates[];
  public mapCoordinatesEdit: ICoordinates[];
  public cities: City[];
  public selectedCity: City;
  public selectedCountry: Country;
  public companies: Company[];
  public selectedCompany: Company;
  public filteredCompanies: Company[] = [];
  public filteredCities: City[] = [];

  public countries = [
    { id: 1, name: 'Colombia', geoName: 'CO' },
    { id: 2, name: 'Mexico', geoName: 'MX' },
  ];

  public options;
  public overlays;

  showEditCediMap = false;

  constructor(
    private cediSvc: CediStoreService,
    private routingSvc: RoutingService,
    private messageService: MessageService,
    private route: Router
  ) {
    /** */
  }

  ngAfterViewInit(): void {
    const labelRef = document.getElementById('mu-file-cedi-load')?.getElementsByClassName('p-button-label')[0];
    if (labelRef) labelRef.innerHTML = 'Cargar Archivo';
  }

  ngOnInit(): void {
    this.routingSvc
      ?.handleCities()
      ?.then(res => (this.cities = res))
      ?.catch(e => {
        throw e;
      });
    this.routingSvc
      ?.handleCompanies()
      ?.then(res => (this.companies = res))
      ?.catch(e => {
        throw e;
      });
    this.editCedi = {
      id: 0,
      address: '',
      name: '',
      lat: 0,
      lng: 0,
      idCity: 0,
      city: '',
      istDistributionCenter: true,
    };

    this.mapCoordinatesEdit = [
      {
        latitude: 0,
        longitude: 0,
        ico: '../../../../../../../assets/images/service/map/ic-pin-recogida.png',
      },
    ];
  }

  async loadExcelPoints($event): Promise<void> {
    const fileId = await this.cediSvc.uploadFile($event.files[0]);
    this.showAddress = !this.showAddress;
    this.handleValidateAddress(fileId);
  }

  deleteAddressFoundPoint(idAddress: number): void {
    this.cediSvc.deleteClientPointServiceAddress(idAddress);
    this.routingSvc
      .deleteCeditableData(idAddress)
      .then(res => {
        if (res) {
          this.addressFound = this.addressFound.filter(item => item.id !== idAddress);
          if (this.addressFound.length === 0 && this.addressNotFound.length === 0) {
            this.route.navigate(['/cedi']);
          } else if (this.addressFound.length === 0 && this.addressNotFound.length > 0) {
            this.messageService.add({
              severity: 'warn',
              summary: 'CEDI',
              detail: 'Por favor  valide todas las direcciones Encontradas, No encontradas',
            });
          }

          this.messageService.add({ severity: 'success', summary: 'CEDI', detail: ' El punto Fue eliminado con éxito!' });
        }
      })
      .catch(err => {
        this.messageService.add({
          severity: 'error',
          summary: 'CEDI',
          detail: 'No es posible ejecutar la acción. Comunicate con el administrador',
        });
      });
  }

  deleteNotFoundPoint(i: number): void {
    this.addressNotFound = this.addressNotFound.filter((res, index) => index !== i);
    if (this.addressNotFound.length === 0) {
      this.route.navigate(['/cedi']);
    }
  }

  updateAddressFounPoint(idPoint: NewPointCedi, index: number): void {
    this.editCedi = {
      ...this.editCedi,
      ...{
        id: idPoint.id,
        address: idPoint.address,
        name: idPoint.name ? idPoint.name : ' ',
        lat: idPoint.lat,
        lng: idPoint.lng,
        idCity: this.selectedCity.id,
        city: this.selectedCity.name,
        istDistributionCenter: idPoint.istDistributionCenter,
      },
    };
    this.showEditCedi = !this.showEditCedi;
  }

  updateAddressPoint(address: string, i: number): void {
    this.editCedi = {
      ...this.editCedi,
      ...{
        address,
      },
    };
    this.showEditCedi = !this.showEditCedi;
  }

  handleEditCedi(): void {
    this.showEditCedi = !this.showEditCedi;
  }

  returnClickMap(event): void {
    const address = JSON.parse(event);
    this.routingSvc.handleLatToLng('bogota', address.latitude, address.longitude).then(res => {
      this.addressToEdit = res.address;
      this.editCedi[0].lat = res.location.lat.toString();
      this.editCedi[0].lng = res.location.lng.toString();
    });
  }

  handleEditAddress(): void {
    if (this.addressNotFound.length - 1 > 0) {
      this.addressNotFound = this.addressNotFound.filter(res => res.address !== this.editCedi.address);
      this.showEditCedi = !this.showEditCedi;
      this.showSuccess();
    } else {
      this.route.navigate(['/cedi']);
    }
  }

  filterCities($event) {
    this.filteredCities = [];
    this.cities.forEach(city => {
      if (city.name.toLowerCase().indexOf($event.query.toLowerCase()) === 0) {
        this.filteredCities.push(city);
      }
    });
  }

  filterCompanies($event) {
    this.filteredCompanies = [];
    this.companies.forEach(city => {
      if (city.name.toLowerCase().indexOf($event.query.toLowerCase()) === 0) {
        this.filteredCompanies.push(city);
      }
    });
  }

  showSuccess(): void {
    this.messageService.add({ severity: 'success', summary: 'CEDI', detail: ' El punto Fue editado con éxito!' });
  }

  handleValidateAddress(fileId: string): void {
    this.routingSvc
      .createCediTableDataClient(this.selectedCompany.id, fileId)
      .then(res => {
        this.addressPoint = res;

        this.addressFound = res.filter(item => item.status === 'OK');
        this.mapCoordinates = this.addressFound.map(item => ({
          latitude: +item.lat,
          longitude: +item.lng,
          ico: '../../../../../../../assets/images/service/map/ic-pin-recogida.png',
        }));
        this.addressNotFound = res.filter(item => item.status !== 'OK');
      })
      .catch(e => {
        throw e;
      });
  }

  callShow(event): void {
    this.showEditCediMap = true;
  }

  handleListCedi(): void {
    this.route.navigate(['/cedi']);
  }
}
